<script setup lang="ts" name="TimelineCharBar">
import { computed } from 'vue';

import { CATEGORICAL_DAVIZ_COLORS_TO_TAG } from '~/constants';

import type { ITimelineChartBaseBarDetails } from '~/types';

const { color, isFaded } = defineProps<{
  leftOffset: number;
  width: number;
  color: string;
  details: ITimelineChartBaseBarDetails;
  isFaded: boolean;
}>();

const COLOR_STYLE_MAP = {
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.OCEAN_8]: {
    border: 'border-ocean-9',
    fadedBorder: 'border-ocean-2',
    fadedBackground: 'bg-ocean-2',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.ORANGE_3]: {
    border: 'border-orange-4',
    fadedBorder: 'border-orange-1',
    fadedBackground: 'bg-orange-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.OCEAN_4]: {
    border: 'border-ocean-5',
    fadedBorder: 'border-ocean-1',
    fadedBackground: 'bg-ocean-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.PURPLE_3]: {
    border: 'border-purple-4',
    fadedBorder: 'border-purple-1',
    fadedBackground: 'bg-purple-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.NAVY_BLUE_7]: {
    border: 'border-navy-blue-8',
    fadedBorder: 'border-navy-blue-1',
    fadedBackground: 'bg-navy-blue-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.MAGENTA_8]: {
    border: 'border-magenta-9',
    fadedBorder: 'border-magenta-1',
    fadedBackground: 'bg-magenta-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.INDIGO_9]: {
    border: 'border-indigo-10',
    fadedBorder: 'border-indigo-1',
    fadedBackground: 'bg-indigo-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.AMBER_9]: {
    border: 'border-amber-10',
    fadedBorder: 'border-amber-1',
    fadedBackground: 'bg-amber-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.CHESTNUT_9]: {
    border: 'border-chestnut-10',
    fadedBorder: 'border-chestnut-1',
    fadedBackground: 'bg-chestnut-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.PINK_4]: {
    border: 'border-pink-5',
    fadedBorder: 'border-pink-1',
    fadedBackground: 'bg-pink-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.NAVY_BLUE_10]: {
    border: 'border-navy-blue-9',
    fadedBorder: 'border-navy-blue-1',
    fadedBackground: 'bg-navy-blue-1',
  },
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.GREEN_8]: {
    border: 'border-green-9',
    fadedBorder: 'border-green-1',
    fadedBackground: 'bg-green-1',
  },
};

const borderColor = computed(() =>
  isFaded ? COLOR_STYLE_MAP[color].fadedBorder : COLOR_STYLE_MAP[color].border,
);
const backgroundColor = computed(() =>
  isFaded ? COLOR_STYLE_MAP[color].fadedBackground : color,
);
</script>

<template>
  <div
    class="absolute z-20 flex h-[36px] items-center rounded-md border px-2"
    :class="[borderColor, backgroundColor]"
    :style="{
      left: `${leftOffset}px`,
      width: `${width}px`,
    }"
  >
    <p class="truncate" v-title>
      <span class="text-caption font-bold tracking-wide"
        >{{ details.name }}&nbsp;</span
      >
      <span class="text-caption">
        {{ details.status }}: {{ details.date }}
      </span>
    </p>
  </div>
</template>
